import { render, staticRenderFns } from "./BaseBoxSection.vue?vue&type=template&id=201885fc&"
import script from "./BaseBoxSection.vue?vue&type=script&lang=js&"
export * from "./BaseBoxSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports